export default "__VITE_ASSET__DDTar_eX__"